<head>
  <script async src="https://www.googletagmanager.com/gtag/js?id=UA-165920778-2"></script>
  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', 'UA-165920778-2');
  </script>
</head>
<div class="text">
<div class="" >
  
  <div  #alert class="alert   p-2 alert-dismissible fade mb-0 show" role="alert">
    <button type="button" class="close p-3" aria-label="Close" (click)="closeAlert()">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="row mt-3">
       
      <div class="col-sm-12">
        <div class=" ">
          <h4 class="font-weignt-bold"> FastSwiff Mobile app</h4>
          <p class="card-text">For Better Experience <a href="http://onelink.to/h3xt9n" target="_blank">download our app  </a>  </p>
         
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<!-- style="background: url(assets/img/login-new-bg.png); background-size: cover;background-color: #dddddf;"       style="background: url(assets/img/background-bg.png); background-size: cover;" -->

<div class="container-fluid p-sm-0">
    <div class="p-md-5">
      <div class="container">
      <div class="login_card card p-0">
        <div class="row">
          <div class="col-md-6 order-sm-12">
            <div class="loginDiv">
              <div class="card-5 py-md-5 ">
                <h3 class="mb-3">Sign in to your account</h3>
                
                <form  #loginform="ngForm" (ngSubmit)="checkUserNameverfication()">
                  
                  <div class="form-group clear" data-validate="Valid email is required: ex@abc.xyz"> 
                    <!-- <label class="customlabel"> Email/Mobile No*</label> -->
                    <!-- (change)="checkvposlogin()" -->
                    <img src="assets/img/email.svg" class="login_icon"/>
                    <input type="text" placeholder="Email/MobileNo"  id="email" name="email" [formControl]="email"   required  class="formcontrol-user11 form-control input_icon" required>  
                
                </div>
                <span class="text-danger" *ngIf="email.invalid && (email.dirty || email.touched)">{{emailerrors()}} </span> 
                <small style="color:red;" *ngIf="usernameerror">UserName is Invalid</small>
              <!-- <div class="clear"></div> -->
                <div class="form-group clear" data-validate="Password is required">
                  <!-- <label class="customlabel"> Password*</label> -->
                  <img src="assets/img/lock.svg" class="login_icon" style="width: 27px; top: 14px;"/>
                  <input   class="formcontrol-user11 form-control input_icon" placeholder="Password"  type="password" id="password" name="password" aria-label="password"
                  input [type]=" showPassword ? 'text' : 'password' " 
                  [formControl]="password" required>  
                  <img src="assets/img/dashboard_icons/view.svg" class="view_icon"  (click)=" showHidePassword()" *ngIf="isView" />
                  <img src="assets/img/dashboard_icons/no_view.svg" (click)=" showHidePassword()" class="view_icon" *ngIf="isNoView" />
                <!-- validationns -->
                </div>
                
                
                <!-- <input type = "checkbox" (click)=" showHidePassword()" style="background: #d4d1d8 !important;" > &nbsp; Show Password -->
                <span class="forgotPassword">
                  Forgot your Password? &nbsp; <a [routerLink]="['/registration/passwordverififcation']"  class="mt-4" *ngIf="indiafields" >Click Here</a>
                  <a [routerLink]="['/us/en/registration/passwordverififcation']"  class="mt-4"  *ngIf="Usfields" >Click Here</a>
                  <a [routerLink]="['/in/te/registration/passwordverififcation']"  class="mt-4" *ngIf="itl" >Click Here</a>
                  <a [routerLink]="['/in/en/registration/passwordverififcation']"  class="mt-4"  *ngIf="ien">Click Here</a>
                  <a [routerLink]="['/in/hi/registration/passwordverififcation']"  class="mt-4"  *ngIf="ihi">Click Here</a>
                </span>
                <div class="clear"></div>
                <span class="text-danger" *ngIf="password.invalid && (password.dirty || password.touched)">
                  {{passworderrors()}} 
                </span>
              <!-- validations content -->
              
              <small style="color:red;" *ngIf="ipaddressrequired">Please allow ip address to login</small>
                <small style="color:red;" *ngIf="isloginfailed">UserName or Password is Invalid</small>
                <small style="color:red;" *ngIf="AccountBlocked">Your Account Is Blocked Please try to Login After 24 Hours</small>
      
                <small style="color:red;" *ngIf="isPasswordExpired">password expired</small>
                <small style="color:red;" *ngIf="!isValidMerchant">Merchant Id was not found with given details</small>
                <small style="color:red;" *ngIf="isMerchantNotActive">Merchant Id is not an Active</small>
      
                <small style="color:red;" *ngIf="isAccountRejected">Your Account was Rejected</small>
                <small style="color:red;" *ngIf="isAccountVerificationPending">Verification pending for your
                  Account</small>
                <small style="color:red;" *ngIf="isAccountOnHold">Sorry!, You can not login now due to your account was  OnHold</small>
                <small style="color:red;" *ngIf="isAccountCancled">Sorry!, You can not login due to your account was Cancelled</small>
                <small style="color:red;" *ngIf="isAccountDeclined">Sorry!, You can not login due to your account was  Declined</small>
                <small style="color:red;" *ngIf="isEmailConfirmationPending">Email Confirmation is pending, please check your Email to continue with us. </small>
                <small style="color:red;" *ngIf="isIpAddressVerified">{{ipAddressValidationMsg}} </small>
                <div class="text-center login_component_css mt-3">
                  <!-- <button type="submit" class=" btn btn-new" [disabled]="password.invalid ||email.invalid ||usernameerror">Log in</button> -->
                  <button type="submit" class="btn login_button text-center" [disabled]="password.invalid ||email.invalid ||usernameerror">Log in</button> <br/> <br/>
                  <!-- <a [routerLink]="['/registration/passwordverififcation']"  class="text-right d-block" *ngIf="indiafields" >Forgot password</a>
                  <a [routerLink]="['/us/en/registration/passwordverififcation']"  class="text-right d-block"  *ngIf="Usfields" >Forgot password</a>
                  <a [routerLink]="['/in/te/registration/passwordverififcation']"  class="text-right d-block" *ngIf="itl" >Forgot password</a>
                  <a [routerLink]="['/in/en/registration/passwordverififcation']"  class="text-right d-block"  *ngIf="ien">Forgot password</a>
                  <a [routerLink]="['/in/hi/registration/passwordverififcation']"  class="text-right d-block"  *ngIf="ihi">Forgot password</a> -->
                  
                </div>
              
                </form>
                <p class="gray-t l-h21 account_creation text-center">Don’t Have an account? 
                
                  <a  [routerLink]="['/registration/CreateMerchant']" *ngIf="indiafields">Sign Up</a>
                  <a  [routerLink]="['/us/en/registration/CreateMerchant']" *ngIf="Usfields">Sign Up</a>
                  <a  [routerLink]="['/in/te/registration/CreateMerchant']" *ngIf="itl">Sign Up</a>
                  <a  [routerLink]="['/in/en/registration/CreateMerchant']" *ngIf="ien">Sign Up</a>
                  <a  [routerLink]="['/in/hi/registration/CreateMerchant']" *ngIf="ihi">Sign Up</a>
                </p>
              </div>
            </div>
          </div>
          <!-- style="background: url(assets/img/bg.svg); background-size: cover;" -->
          <div class="col-md-6  pb-sm-03 order-sm-1" style="background: url(assets/img/bg.svg); background-size: cover;">
              <div class="login_form_div">
                <div class="row">
                  <!-- <div class="col-md-12 p-md-0">
                    <img src="assets/img/logo.png" alt="">
                  </div> -->
                  <div class="col-md-12 p-md-0" *ngIf="paygimage">
                    <img class="img-fluid mt-2 ml-3" src="assets/img/white_logo.svg" alt="FastSwiff" />
                  </div>
                  <div class="col-md-12 brand-logo text-center" *ngIf="image">
                    <!-- <img  [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}" class="res-h img-fluid image-cropper-container1" src="data:image/jpeg;base64,{{content}}" alt="FastSwiff" /> -->
                  </div>
                  <div class="col-md-12 loginImg text-center">
                      <img src="assets/img/login.png" class="img-fluid" />
                  </div>
                  <div class="col-md-12 downloadDiv mt-4">
                    <a href="https://play.google.com/store/apps/details?id=com.paygdigitals.payg" target="_blank"> <img src="assets/img/new/playstore-btn.png" alt="playstore-btn"  ></a>
                    <a  href="https://apps.apple.com/us/app/payg-app/id1663144980" target="_blank"> <img src="assets/img/new/app-store-btn.png" class="ml-3" alt="app-store-btn"  ></a>
                  </div>
                  <div class="col-md-12 text-center">
                    <!-- <ul class="login-ul">
                    
                      <li>
                        <h5>Get started quickly  </h5>
                        <p>Completely online onboarding & best in class security  </p>
                      </li>
                      <li>
                        <h5>Fast Integration</h5>
                    
                        <p> Easy to integrate API and SDK documentation for developers</p>
                      </li>
                    
                      <li>
                        <h5>Dashboard Reporting</h5>
                        <p>Get complete insight of your business with smart analytics, reports and charts </p>
                      </li>
                      <li>
                        <h5>Robust Security</h5>
                        <p>Industry standard 100% PCI DSS Compliant & Certified solution </p>
                      </li>
                      <li *ngIf="hidebutton">
                        <h5>Switch to FastSwiff Mobile app </h5>
                        <p>Download the FastSwiff app to access your FastSwiff account from anywhere, anytime</p>
                        <a href="https://play.google.com/store/apps/details?id=com.xsilica.paygfuturepos" target="_blank"> <img src="assets/img/new/playstore-btn.png" alt="playstore-btn"  ></a>
                        <a  href="https://apps.apple.com/us/app/payg-future-pos/id1567618603" target="_blank"> <img src="assets/img/new/app-store-btn.png" class="ml-3" alt="app-store-btn"  ></a>
                      </li>
                    
                    </ul> -->
                    <!-- <div class="text-center">
                      <img src="assets/img/login.png" class="img-fluid" />
                    </div> -->
                    <div class="mb-2 mt-3"></div>
                  </div>
                  <!-- <div *ngIf="paygname"> © FastSwiff </div>
                  <div *ngIf="resellername"> ©{{whitelableName}}</div> -->
                  <div class="col-md-12 footer_content mt-4">
                    <p style="color:#fff; font-weight: 600;" *ngIf="hidebutton">
                      <span *ngIf="paygname">© FastSwiff</span> &nbsp; &nbsp;
                      <span *ngIf="resellername">©{{whitelableName}}</span> &nbsp; &nbsp;
                      &nbsp;&nbsp; <a style="color:#fff; font-weight: 600;"  href="https://fastswiff.com/contact.html" target="_blank" >Contact Us</a>&nbsp; &nbsp;
                      <a style="color:#fff; font-weight: 600;" href="https://developer.fastswiff.com/" target="_blank" >Developer</a>&nbsp;&nbsp;
                      <a style="color:#fff; font-weight: 600;" href="https://fastswiff.com/care/Support" target="_blank" >Care</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      </div>
    </div>

</div> 



<!-- <section class="body">
  <div class="container-fluid">
    <div class="row bg-white">
      <div class="col-lg-6 col-md-12 p-0">
        <div style="  background-image: url(assets/img/new/login-bg.png); background-repeat: no-repeat; background-size: cover;">
          <div class="px-3 pt-4 pb-2 text-center">
            <img   src="assets/img/new/sign-bg.png" class="w-100"/>
            <div class="pt-3 pl-3 text-left">
              <img src="assets/img/new/black-logo.png" width="150" height="60"/>
              <h4 class="text-white font-36 l-h55">Welcome To FastSwiff <span class="d-block">Virtual Terminal</span></h4>
              <div class="border-white-line"></div>
              <p class="text-white pt-2 l-h21 font200">Virtual Terminal has a great new look and feel, ready for you to continue your clients payment processing. Click the Register Button to be redirected to the new login page.</p>
              <div class="row py-3">
                <div class="col-md-3">
                  <img class="d-inline" src="assets/img/new/icon-awesome-phone.svg"/> 
                  <p class="text-white pt-2 l-h21 font200 d-inline ml-2">+917337327109</p>
                </div>
                <div class="col-md-3">
                  <img class="d-inline" src="assets/img/new/ionic-md-mail.svg"/> 
                  <p class="text-white pt-2 l-h21 font200 d-inline ml-2">care@fastswiff.com</p>
                </div>
                <div class="col-md-6 text-right pr-5 pb-2">
                  <div class="social-icons text-right  poppins">
                    <a  href="https://www.facebook.com/FastSwiffIndia/" target="_blank" ><i class="fab fa-facebook"></i></a>  <a href="https://twitter.com/FastSwiffIndia"  target="_blank"><i class="fab fa-twitter"></i></a>
                    <a href="https://www.instagram.com/paygindia/"  target="_blank"><i class="fab fa-instagram"></i></a>
                    <a href="https://www.linkedin.com/company/pay-g"  target="_blank"><i class="fab fa-linkedin-in"></i></a>
                    <a href="https://www.youtube.com/watch?v=IEbSqP5Q18Y"  target="_blank"><i class="fab fa-youtube"></i></a>
                    <a href="https://in.pinterest.com/paygindia/"  target="_blank"><i class="fab fa-pinterest-p"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-5 col-md-12 p-0 bg-white">
        <div class="sign-p">
          <h6 class="font-16 gray-t">Sign In</h6>
          <h4 class="font-30 gray-t l-h46">Get Started</h4>
          <h5 class="font-20 l-h30 pb-2">Please Fill your details to login your account</h5>
        
     
        </div>    
      </div>
      </div>
    </div>
  
</section>
  -->